export const TableExpandWithAccordionDecorator = function (
  rowKeyField: string = "__index__"
) {
  return function (constructor) {
    const prototype = constructor.prototype;

    // 展开的key数组
    prototype.expandKeys = [];

    prototype.rowClick = function (row) {
      // 实现手风琴类似的效果
      if (row[rowKeyField] === this.expandKeys[0]) {
        this.expandKeys = [];
      } else {
        this.expandKeys = [];
        this.expandKeys.push(row[rowKeyField]);
      }
    };

    prototype.expandChange = function (row, expandedRows) {
      // 保存最后一个key
      this.expandKeys = expandedRows.slice(-1).map(o => o[rowKeyField]);
    };
  };
};
